export default {
  form: {
    yes: () => window.intl.formatMessage({ id: 'form / yes' }),
    no: () => window.intl.formatMessage({ id: 'form / no' }),
    cancel: () => window.intl.formatMessage({ id: 'form / cancel' }),
    send: () => window.intl.formatMessage({ id: 'form / send' }),
  },
  list: {
    search: () => window.intl.formatMessage({ id: 'list / search' }),
  },
  date: {
    today: () => window.intl.formatMessage({ id: 'date / today' }),
    yesterday: () => window.intl.formatMessage({ id: 'date / yesterday' }),
    from: () => window.intl.formatMessage({ id: 'date / from' }),
    to: () => window.intl.formatMessage({ id: 'date / to' }),
  },
  valid: {
    required: () => window.intl.formatMessage({ id: 'validation / required' }),
  },
  general: {
    edit: () => window.intl.formatMessage({ id: 'edit' }),
  },
}
